import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button, Menu, Dropdown, Input, AutoComplete } from "antd";
import { UserOutlined, DownOutlined, QuestionOutlined, MenuOutlined } from "@ant-design/icons";

import {
  UserData,
} from "../model/model";

import SessionStore from "../model/SessionStore";

const renderTitle = (title: string) => <span>{title}</span>;

const renderItem = (title: string, url: string) => ({
  value: title,
  label: <Link to={url}>{title}</Link>,
});

function Header({ userData, isMobile, onMenuClick }: { userData: UserData; isMobile: boolean; onMenuClick: () => void }) {
  const navigate = useNavigate();


  useEffect(() => {
    // InternalStore.settings((resp: SettingsResponse) => {
    //   setSettings(resp);
    // });
  }, [userData]);


  const onLogout = () => {
      SessionStore.logout(true, () => {
        navigate("/login");
      });
    // }
  };

  const menu = (
    <Menu>
        <Menu.Item>
          <Link to={`/user/${userData.login}/password`}>Change password</Link>
        </Menu.Item>
      <Menu.Item onClick={onLogout}>Logout</Menu.Item>
    </Menu>
  );

  const options: {
    label: JSX.Element;
    options: ReturnType<typeof renderItem>[];
  }[] = [
    {
      label: renderTitle("Sites"),
      options: [],
    },
    {
      label: renderTitle("Gateways"),
      options: [],
    },
    {
      label: renderTitle("Applications"),
      options: [],
    },
    {
      label: renderTitle("Devices"),
      options: [],
    },
  ];

  return (

    <div>
      {isMobile && <Button icon={<MenuOutlined />} onClick={onMenuClick} style={{ marginRight: 16 }} />}
      <img className="logo" alt="MiniServ" src="/logo.png" />
      <div className="actions">

        <div className="help">
          <a href="https://www.tinovi.com" target="_blank" rel="noreferrer">
            <Button icon={<QuestionOutlined />} />
          </a>
        </div>
        <div className="userData">
          <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
            <Button type="primary" icon={<UserOutlined />}>
              {userData.email} <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default Header;
